import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';

export const slideInDown = trigger('slideInDown', [
  state('in', style({ transform: 'translateX(0)' })),
  transition(':enter', [
    animate(
      '250ms ease-out',
      keyframes([
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        style({ transform: 'translateY(0)', opacity: 1 }),
      ])
    ),
  ]),
  transition(':leave', [
    animate(
      '250ms ease-out',
      keyframes([
        style({ transform: 'translateY(0)', opacity: 1, position: 'sticky' }),
        style({ transform: 'translateY(-100%)', opacity: 0 }),
      ])
    ),
  ]),
]);
